import React from 'react';
import { Field } from 'formik';
import { useDebouncedCallback } from 'use-debounce';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

import { BusinessSectorType } from 'store/modules/assistant/assistant';
import IntlProvider, {
  useFormatMessage,
  IntlProviderType,
} from 'components/IntlProvider';
import Fields from 'components/Fields';
import api from 'api';
import { businessSectorsToSelect } from 'store/modules/assistant/utils';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(0.5),
      },
    },
    formControl: {
      marginTop: '16px',
      marginBottom: '8px',
    },
  })
);

const BusinessSectors = ({
  intl,
  disabled,
  sectors,
}: {
  sectors: BusinessSectorType[];
  disabled?: boolean;
  intl: IntlProviderType;
}) => {
  const classes = useStyles();
  const t = useFormatMessage();

  const searchSector = (inputValue: string, callback: any) => {
    return api.resources
      .getAssistantBusinessSectors({
        search: inputValue,
      })
      .then(({ data }) => {
        callback(businessSectorsToSelect(data.results, intl.locale));
      });
  };

  const [debouncedCallback] = useDebouncedCallback(
    (inputValue: string, callback: any) => {
      searchSector(inputValue, callback);
    },
    700
  );

  if (disabled) {
    return (
      <FormControl fullWidth variant="outlined" className={classes.formControl}>
        <InputLabel
          style={{
            transform: 'translate(12px, -6px) scale(0.75)',
            background: 'white',
            padding: '0 .25rem',
            fontWeight: 700,
            zIndex: 11,
          }}
        >
          {t('field.sectors.label', 'Business Sectors')}
        </InputLabel>
        <div className={classes.root}>
          {sectors.map(({ label, value }: BusinessSectorType) => (
            <Chip key={value} label={label} />
          ))}
        </div>
      </FormControl>
    );
  }

  return (
    <Field
      name="business_sectors"
      component={Fields.AsyncSelect}
      loadOptions={debouncedCallback}
      label={t('field.sectors.label', 'Business Sectors')}
      placeholder={t('field.sectors.placeholder', 'Search and select...')}
      isMulti
    />
  );
};

export default IntlProvider.withIntl(BusinessSectors);
